module.exports = __webpack_public_path__ + "static/media/symfoni_logo.1fdf06ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/symfoni_logo.png
// module id = 278
// module chunks = 0